'use strict';
Object.defineProperty(exports, "__esModule", { value: true });
var $ = require("jquery");
var smooth_scroll_1 = require("./require/smooth-scroll");
var push_object_1 = require("./require/push-object");
// import SlickCarousel    from './require/common/slick-carousel';
// import Header           from './require/common/header';
// import Fukidashi        from './require/common/fukidashi';
$(function () {
    new smooth_scroll_1.default();
    new push_object_1.default();
    // $('.draggable').draggable();
});
